import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { RingCentralSettings } from './RingCentralSettings'

export const RingCentralSpecificSettings = (): ClickNavigationSection[] => {
  return [
    {
      id: 'settings',
      label: 'RingCentral Settings',
      content: () => <RingCentralSettings />,
    },
  ]
}
